<template>
	 <div>
		<div class="head">MESSAGE</div>
		
		<ul class="messageList">
			<li class="item"  v-if="messageList.length==0"><i class="iconfont">&#xe773;</i><span>No Data</span></li>
			<li class="item" v-for="item in messageList"><i class="iconfont">&#xe773;</i><span>{{item.title}}</span></li>


		</ul>
		
		
	 </div>
</template>

<script>
 export default {
     data() {
			return {
				messageList:[],
				total:100,
			}
		},
		mounted() {
            var app = this;
			this.$api("/user/message",).then(function(res) {
                app.messageList = res.data;

			})
		},
		methods: {

		}
 }
</script>

<style lang="less" >

.messageList {
	padding-bottom:50px;
	.item {
		display: block;
		line-height: 50px;
		font-size: 16px;
		color: #666;
		cursor: pointer;
		i {
			margin-right: 5px;
			color: #c1c1c1;
			
		}
		&:hover {
			color: #90c31f;
			.iconfont {
				color: #90c31f;
			}
		}
	}
		
}

@media screen and (max-width:768px) {
	.messageList {
		padding:0 4%;
	    .item {
           line-height: 1.6;
           padding-left:0;
           padding:15px 0;
           font-size:12px;
           border-bottom:1px solid #efefef;
           i{
           	  font-size:12px;
           }
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/Message.vue